export type BreadcrumbCollapsePlan = {
  ellipsisAt: number | null;
  hiddenIndices: number[];
  visibleIndices: number[];
};

const measureTrail = (
  itemWidths: number[],
  indices: number[],
  separatorWidth: number,
  ellipsisWidth = 0,
  includeEllipsis = false,
) => {
  const slotCount = indices.length + (includeEllipsis ? 1 : 0);

  if (slotCount === 0) {
    return 0;
  }

  const itemsWidth = indices.reduce((sum, index) => sum + (itemWidths[index] || 0), 0);
  const separators = Math.max(0, slotCount - 1) * separatorWidth;

  return itemsWidth + (includeEllipsis ? ellipsisWidth : 0) + separators;
};

export const planBreadcrumbCollapse = (
  itemWidths: number[],
  containerWidth: number,
  ellipsisWidth: number,
  separatorWidth: number,
): BreadcrumbCollapsePlan => {
  const count = itemWidths.length;
  const allIndices = itemWidths.map((_, index) => index);

  if (count === 0) {
    return { ellipsisAt: null, hiddenIndices: [], visibleIndices: [] };
  }

  if (measureTrail(itemWidths, allIndices, separatorWidth) <= containerWidth) {
    return { ellipsisAt: null, hiddenIndices: [], visibleIndices: allIndices };
  }

  if (count === 1) {
    return { ellipsisAt: null, hiddenIndices: [], visibleIndices: [0] };
  }

  const lastIndex = count - 1;
  const middleHidden = allIndices.slice(1, lastIndex);
  const firstAndLast = [0, lastIndex];

  if (
    middleHidden.length > 0 &&
    measureTrail(itemWidths, firstAndLast, separatorWidth, ellipsisWidth, true) <= containerWidth
  ) {
    return {
      ellipsisAt: 1,
      hiddenIndices: middleHidden,
      visibleIndices: firstAndLast,
    };
  }

  return {
    ellipsisAt: 0,
    hiddenIndices: allIndices.slice(0, lastIndex),
    visibleIndices: [lastIndex],
  };
};
